import he from "he"
import { hyphenateHTMLSync } from "hyphen/fi"
import React from "react"

import styles from "./CoreHeading.module.scss"

const CoreHeading = ({ text, level, align, idAttribute }) => {
  const Heading = level
  const camelCase = require("camelcase")

  const textDecoded = text ? he.decode(text.replace(/&nbsp;/g, " ")) : null

  return (
    <section
      {...(idAttribute ? { id: idAttribute } : {})}
      className={`block-heading block-heading-${align} ${styles.heading} ${
        styles[camelCase("" + align)]
      } ${styles[camelCase("level-" + level)]}`}
    >
      <Heading>
        {textDecoded
          ? hyphenateHTMLSync(textDecoded, { minWordLength: 16 })
          : ""}
      </Heading>
    </section>
  )
}

export default CoreHeading

CoreHeading.defaultProps = {
  level: "h2",
  align: "left",
}
